import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';

import enTranslation from './en.json';
import frTranslation from './fr.json';
import nlTranslation from './nl.json';
import deTranslation from './de.json';

i18n
  .use(initReactI18next)
  .use(ICU)
  .init({
    resources: {
        en: { translation: enTranslation },
        fr: { translation: frTranslation },
        nl: { translation: nlTranslation },
        de: { translation: deTranslation }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;